import { render } from "./jgcc.vue?vue&type=template&id=421f5d9b&scoped=true&ts=true"
import script from "./jgcc.vue?vue&type=script&lang=ts"
export * from "./jgcc.vue?vue&type=script&lang=ts"

import "./jgcc.vue?vue&type=style&index=0&id=421f5d9b&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421f5d9b"]])

export default __exports__